export default "__VITE_ASSET__DLfWPfkt__"